/** @jsx h */
import { h } from 'preact'
import CollaboratorActivity from './CollaboratorActivity'
import Footer from './Footer'
import JourneyClose from '../journeys/Close'
import LocationSection from './LocationSection'
import { OrganizationStickyHeader } from './StickyHeader'
import Feedback from '../feedback/Feedback'
import ProofPointsSection from './ProofPointsSection'
import StoryButtonList from './stories/StoryButtonList'

const OrganizationCard = ({
  avatarUrl,
  claims,
  location,
  name,
  onStoryClick,
  onProofPointClick,
  journeys,
  profile: { description },
  typeLabel,
  onAboutClick,
  showPoweredByProvenanceModal
}) => {
  const proofPoints = [...claims]

  const analyticsContext = `${name} / ${name}`

  return (
    <article class='ClaimCard'>
      <JourneyClose />
      <OrganizationStickyHeader title={name} type={typeLabel} logoUrl={avatarUrl} />
      <div class='ModalCard-content'>
        <StoryButtonList journeys={journeys} onStoryClick={onStoryClick} name={name} analyticsContext={analyticsContext} />

        {proofPoints.length > 0 && <ProofPointsSection proofPoints={proofPoints} onProofPointClick={onProofPointClick} analyticsContext={analyticsContext} />}

        <CollaboratorActivity description={description} />

        {location && <LocationSection {...location} />}

        <Footer
          onAboutClick={onAboutClick}
          showPoweredByProvenanceModal={showPoweredByProvenanceModal}
        >
          <Feedback
            context='Organization'
            organizationName={name}
            analyticsContext={analyticsContext}
            analyticsName={name}
          />
        </Footer>
      </div>
    </article>
  )
}

export default OrganizationCard
